var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMatchCase = function SvgMatchCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m131-252 165-440h79l165 440h-76l-39-112h-178l-40 112zm139-176h131l-64-182h-4zm395 186q-51 0-81-27.5t-30-72.5q0-44 34.5-72.5t88.5-28.5q23 0 45 4t38 11v-12q0-29-20.5-47t-54.5-18q-23 0-42 9.5t-33 27.5l-47-35q24-29 54.5-43t68.5-14q69 0 103 32.5t34 97.5v178h-63v-37h-4q-14 23-38 35t-53 12zm12-54q35 0 59.5-24t24.5-56q-14-8-33.5-12.5t-38.5-4.5q-32 0-50 14t-18 37q0 20 16 33t40 13z"
  })));
};
export default SvgMatchCase;